import {
  Button,
  TextInput,
  PasswordInput,
  Stack,
  Group,
  Center,
  Anchor,
  Box,
  Container,
} from '@mantine/core';
import { notifications } from '@mantine/notifications';
import { useParams } from 'react-router';
import { useIntl } from 'react-intl';
import { Link as ReactRouterLink } from 'react-router';
import { useState } from 'react';
import routes from '@commons/routes';
import { myFetch } from '@commons/fetch';
import { useClient } from '@contexts/ClientContext';

export const ClientLogin = () => {
  const intl = useIntl();
  const { login } = useClient();
  const { folderName } = useParams();
  const [password, setPassword] = useState<string>('');
  const [localFolderName, setLocalFolderName] = useState<string>(
    folderName || ''
  );

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    if (localFolderName !== '' && password !== '') {
      try {
        const response = await myFetch(
          `/folders/${localFolderName}/authenticate`,
          {
            method: 'POST',
            body: JSON.stringify({ password }),
          }
        );

        login(response.data);
      } catch (err: any) {
        setPassword('');
        notifications.show({
          title: intl.formatMessage({ id: 'error' }),
          message: err.message,
          color: 'red',
          autoClose: 3000,
        });
      }
    }
  };

  return (
    <Container size={500}>
      <Center h="100svh">
        <Box w="100%">
          <form onSubmit={handleSubmit}>
            <Stack gap="md">
              {!folderName && (
                <TextInput
                  label={intl.formatMessage({ id: 'idContract' })}
                  name="folderName"
                  value={localFolderName || ''}
                  onChange={(e) =>
                    setLocalFolderName(e.target.value.toUpperCase())
                  }
                />
              )}

              <PasswordInput
                label={intl.formatMessage({ id: 'access.password' })}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                name="password"
              />

              <Group justify="space-between" align="center">
                <Anchor
                  component={ReactRouterLink}
                  to={routes.root}
                  size="sm"
                  c="blue"
                >
                  {intl.formatMessage({ id: 'backToHome' })}
                </Anchor>

                <Button id="access-submit-button" type="submit">
                  {intl.formatMessage({ id: 'access' })}
                </Button>
              </Group>
            </Stack>
          </form>
        </Box>
      </Center>
    </Container>
  );
};
